// Header icons
import React from 'react';
import homeworkImg from '@/assets/images/homework.webp';
import missingLessonsImg from '@/assets/images/missing-lessons.webp';
import newsImg from '@/assets/images/news.webp';
import testworkImg from '@/assets/images/testwork.webp';
import type { IconComponentProps } from '@/types/components';

export const AbsenceIllustration: React.FC<IconComponentProps> = ({
  className,
}) => <img src={missingLessonsImg} alt="" className={className} />;

export const NewsIllustration: React.FC<IconComponentProps> = ({
  className,
}) => <img src={newsImg} alt="" className={className} />;

export const HomeworkIllustration: React.FC<IconComponentProps> = ({
  className,
}) => <img src={homeworkImg} alt="" className={className} />;

export const TestScheduleIllustration: React.FC<IconComponentProps> = ({
  className,
}) => <img src={testworkImg} alt="" className={className} />;
